import supabase from 'modules/core/supabase/supabase';
import { mapChampionshipSettings } from 'modules/championship/domain/data-mappers/championship-settings.data-mapper';
import getGameInfo from '../repositories/match-by-id';
import { updateFoulPeriods } from './update-foul-periods';
import { updateMembersStats } from './update-members-stats';

export async function getMappedGameInfo(matchId: number) {
  const gameInfo = await getGameInfo(matchId);
  if (!gameInfo) return undefined;

  const settings = mapChampionshipSettings(gameInfo.championship?.settings);
  supabase.matchChronology.init(settings);

  // Ошибку пропускаем наверх как есть: незаполненный регламент отличает от прочих сбоев
  // `isMatchPeriodsSettingsMissing`, и объясняет его тот, кто запускал синхронизацию.
  if (gameInfo.match?.id) {
    const events = await supabase.matchChronology.getRow(gameInfo?.match?.id ?? 0);
    if (events) {
      await updateMembersStats(gameInfo, events);
      await updateFoulPeriods(gameInfo, events);
    }
  }

  return gameInfo;
}
